import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Card} from 'antd';

import _ from 'lodash';

import * as actions from '../redux/actions/index';
import AreaChart from "../charts/AreaChart";

class StateAreaCard extends Component {
  render() {
    const onClick = year => {
      this.props.actions.selectYear(year);
    };

    return (
      <Card className="StateAreaCard" noHovering={true} loading={this.props.loading}>
        <h2 className="subtitle">
          {this.props.selectedState.name} Selected Dimensions Over Time<br/>
          <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e04040"></rect></svg>
          {this.props.xLabel} &nbsp;
          <small>vs</small> &nbsp;
          <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#0f8ee9"></rect></svg>
          {this.props.yLabel}
        </h2>
        <AreaChart
          dimX={this.props.xField}
          dimY={this.props.yField}
          titleX={this.props.xLabel}
          titleY={this.props.yLabel}
          year={this.props.year}
          data={this.props.data}
          onClick={onClick}
        />
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  const stateFips = _.get(store, ['states', 'selected', 'fips']);
  const stateData = _.get(store, ['states', 'dict', stateFips], {});

  return {
    loading: store.states.loading || store.dimensions.loading,
    selectedState: store.states.selected,
    data: stateData,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(StateAreaCard);



// WEBPACK FOOTER //
// ./src/containers/StateAreaCard.js